import React from 'react';
import PropTypes from 'prop-types';
import PlaneIcon from 'assets/icons/PlaneIcon';
import PortIcon from 'assets/icons/PortIcon';
import TrainIcon from 'assets/icons/TrainIcon';
import theme from 'theme/theme';

// Map icons to POI types
const iconMapping = {
    'airport': PlaneIcon,
    'port': PortIcon,
    'station': TrainIcon,
};

export const hasIcon = (id) => {
    return !!iconMapping[id];
};

const PointOfInterestTypeIcon = (props) => {
    const { type } = props;

    if (!type) {
        return null;
    }

    const IconComponent = iconMapping[type];

    return <IconComponent primary={ theme.palette.primary1Color } />;
};

PointOfInterestTypeIcon.propTypes = {
    type: PropTypes.string,
};

export default PointOfInterestTypeIcon;



// WEBPACK FOOTER //
// ./src/components/field/PointOfInterestTypeIcon.js